/** Association admin · Supply & Demand (fixed UI copy) */
export default {
  pageTitle: 'Supply & Demand',
  tabList: 'Listings',
  tabCategories: 'Categories',
  tabSettings: 'Circle settings',

  searchPlaceholder: 'Search title / content / category',
  searchCategoryPlaceholder: 'Search',
  filterAll: 'All',
  filterShow: 'Visible',
  filterHide: 'Hidden',
  add: 'Add',
  refresh: 'Refresh',
  emptyList: 'No matching records',
  emptyCategories: 'No categories yet',
  paginationRange: 'Showing {from} to {to} of {total} records',

  colId: 'Id',
  colCategoryName: 'Category',
  colPublisherName: 'Publisher',
  colTitle: 'Title',
  colCreatedAt: 'Created at',
  colUpdatedAt: 'Updated at',
  colSortOrder: 'Weight',
  colDisplayStatus: 'Visibility',
  colAuditStatus: 'Review status',
  colStatus: 'Status',
  colActions: 'Actions',
  colCategoryId: 'ID',
  colSort: 'Sort',
  statusShow: 'Visible',
  statusHide: 'Hidden',
  auditPending: 'Pending',
  auditApproved: 'Approved',
  auditRejected: 'Rejected',
  btnAudit: 'Review',
  btnApprove: 'Approve',
  btnReject: 'Reject',
  dialogAudit: 'Review listing',
  fieldRejectReason: 'Rejection reason',
  fieldRejectReasonPlaceholder: 'Required when rejecting',
  ruleRejectReasonRequired: 'Please enter a rejection reason',
  auditSaved: 'Review saved',

  dialogAdd: 'Add',
  dialogEdit: 'Edit',
  fieldCategory: 'Category',
  fieldCategoryPlaceholder: 'Select a category',
  fieldPublisher: 'Publisher',
  fieldPublisherPlatform: 'Platform',
  fieldPublisherNote1: 'Notes:',
  fieldPublisherNote2: '1. Platform posts show association info and phone by default;',
  fieldPublisherNote3: '2. Member posts show member info and phone by default;',
  fieldTitle: 'Title',
  fieldContent: 'Content',
  fieldAddress: 'Address',
  fieldAddressPlaceholder: 'Enter address',
  fieldImages: 'Images',
  fieldImagesUpload: 'Upload',
  fieldImagesHint: 'Up to 9 images; jpg / png / webp',
  auditNoImages: 'No images',
  fieldWeight: 'Weight',
  fieldStatus: 'Status',
  fieldCategoryName: 'Category name',
  fieldCategoryNamePlaceholder: 'Enter category name',
  fieldSort: 'Sort',
  confirm: 'OK',

  settingsVisibility: 'Visibility:',
  visibilityOpen: 'Open to all',
  visibilityPartial: 'Partially open',
  visibilityMember: 'Members only',
  settingsNotesTitle: 'Notes:',
  settingsNote1: '1. Open to all: list and detail pages are public;',
  settingsNote2: '2. Partially open: list is public; detail and calling require membership;',
  settingsNote3: '3. Members only: only approved association members can view.',
  settingsAudit: 'Require review:',
  auditYes: 'Yes',
  auditNo: 'No',

  tip: 'Notice',
  deleteDemandConfirm: 'Delete “{title}”?',
  deleteCategoryConfirm: 'Delete category “{name}”?',
  loadFailed: 'Failed to load',
  loadSettingsFailed: 'Failed to load settings',
  saveFailed: 'Failed to save',
  deleteFailed: 'Failed to delete',
  uploadFailed: 'Upload failed',
  imageUploaded: 'Image uploaded',
  created: 'Created',
  updated: 'Updated',
  deleted: 'Deleted',
  categoryCreated: 'Category created',
  categoryUpdated: 'Category updated',
  settingsSaved: 'Circle settings saved',

  ruleCategoryRequired: 'Please select a category',
  ruleTitleRequired: 'Please enter a title',
  ruleStatusRequired: 'Please select a status',
  ruleCategoryNameRequired: 'Please enter a category name',

  memberFallback: 'Member #{id}'
}
